export default {
    namespaced: true,
    state: {
        errors: {
            sendInvitation: {}
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async sendInvitation({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'sendInvitation',
                val: {}
            })

            const url = '/user/invite'

            try {
                const resp = await this.$axios.post(url, data)
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'sendInvitation',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'sendInvitation',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        },
        resetErrors({ commit }) {
            commit('SET_ERRORS', {
                key: 'sendInvitation',
                val: {}
            })
        }
    }
}
